export default __webpack_public_path__ + "static/media/VA-logo@2x.0bf988ac.png";